import React from 'react';
import SalesIndex from './whole';

export default function () {
  return <SalesIndex version="family" ctaNoTimer />;
}
